import { BUS_IFRAME_ELM_ID } from '@main/config/bus.config';

export class BusIframe {
  private static busIframePromise: Promise<HTMLIFrameElement>;

  static addIframe(iframeUrl: string): Promise<HTMLIFrameElement> {
    if (!this.busIframePromise) {
      this.busIframePromise = new Promise((res, rej) => {
        const iframeSrc = `${iframeUrl}?t=${+new Date()}`;
        const iframe = document.createElement('iframe');

        iframe.setAttribute('id', BUS_IFRAME_ELM_ID);
        iframe.setAttribute('allow', 'microphone; autoplay');
        iframe.width = `0`;
        iframe.height = `0`;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');

        iframe.onload = () => {
          console.log('iframe onload method');
          res(iframe);
        };

        iframe.onerror = (event) => {
          rej(event);
        };

        iframe.src = iframeSrc;
        document.body.appendChild(iframe);
      });
    }

    return this.busIframePromise;
  }

  static async getIframe(): Promise<HTMLIFrameElement> {
    return this.busIframePromise;
  }
}
